<h3 class="text-primary mb-0 pr-2" *ngIf="score$">{{ score$ | async }}/ {{ total }}</h3>
